import { createAxiosClient } from "@ntg/component-library/utilities";
import { useMutation } from "@tanstack/react-query";

const apiClient = createAxiosClient("D365FO");

interface ICommitToManufacturingPayload {
    mItemID: number;
}

async function commitToManufacturing(
    payload: ICommitToManufacturingPayload,
): Promise<string> {
    const response = await apiClient.post<string>(
        "/FunctionAppsStarter/CommitToManufacturing",
        payload.mItemID,
        { headers: { "Content-Type": "application/json" } },
    );
    return response.data;
}

export function useCommitToManufacturingMutation() {
    return useMutation({
        mutationFn: commitToManufacturing,
    });
}
